import React, { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import ReservationModal from "./ReservationModal";
import EditModal from "./EditModal";
import { isMobile } from "react-device-detect";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

export default function Parking2() {
  const [userStatus, setUserStatus] = useState();
  const [placesFromDB, setPlacesFromDB] = useState({});
  const [placesFromDB2, setPlacesFromDB2] = useState({});
  const [placesFromDB3, setPlacesFromDB3] = useState({});
  const [place, setPlace] = useState();
  const [placeData, setPlaceData] = useState();
  const [change, setChange] = useState(false);
  const [changeType, setChangeType] = useState(false);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [parking, setParking] = useState(true);

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserStatus(user.displayName);
      }
    });
  }, []);

  // Funkcja do pobierania danych z Firebase
  const getPlaces = async () => {
    const docRef = doc(db, "parking2", "mQ3zxWVUE914aWxKcXVA");
    const response = await getDoc(docRef);

    if (response.exists()) {
      const parking1 = response.data().parking;
      const placesObj = {};
      if (parking1) {
        parking1.forEach((takenSeat) => {
          if (takenSeat.parking === "1A") {
            placesObj[takenSeat.place] = {
              date: takenSeat.date,
              containerNumber: takenSeat.containerNumber,
              type: takenSeat.type,
              uid: takenSeat.uid,
              parking: takenSeat.parking,
              place: takenSeat.place,
            };
          }
        });
      }

      const placesObj2 = {};
      if (parking1) {
        parking1.forEach((takenSeat) => {
          if (takenSeat.parking === "1B") {
            placesObj2[takenSeat.place] = {
              date: takenSeat.date,
              containerNumber: takenSeat.containerNumber,
              type: takenSeat.type,
              uid: takenSeat.uid,
              parking: takenSeat.parking,
              place: takenSeat.place,
            };
          }
        });
      }

      const placesObj3 = {};
      if (parking1) {
        parking1.forEach((takenSeat) => {
          if (takenSeat.parking === "1C") {
            placesObj3[takenSeat.place] = {
              date: takenSeat.date,
              containerNumber: takenSeat.containerNumber,
              type: takenSeat.type,
              uid: takenSeat.uid,
              parking: takenSeat.parking,
              place: takenSeat.place,
            };
          }
        });
      }

      setPlacesFromDB(placesObj);
      setPlacesFromDB2(placesObj2);
      setPlacesFromDB3(placesObj3);
    }
  };

  useEffect(() => {
    getPlaces(); // Pobierz miejsca na początku
  }, [change]);

  const renderPlace1 = (placeId) => {
    const placeData = placesFromDB[placeId];

    const parkingSpace = (
      <div
        onClick={(e) => {
          if (placeData) {
            setChangeType(!changeType);
            setPlaceData(placeData);
            setOpen2(true);
          } else {
            setChangeType(!changeType);
            setParking("1A");
            setPlace(placeId);
            setOpen(true);
          }
        }}
        className={`parking-space-3 ${
          placeData && placeData.type === "Amazon"
            ? "amazon-place"
            : placeData && placeData.type === "Slam"
            ? "slam-place"
            : ""
        }`}
      >
        <div className="parking-space-3">
          {placeData && <p>{placeData.containerNumber}</p>}
        </div>
      </div>
    );

    return parkingSpace;
  };


  const btn_1 = document.querySelector(".btn-12");
  const btn_2 = document.querySelector(".btn-22");

  useEffect(() => {
    if (parking && btn_1 && btn_2) {
      btn_1.classList.add("btn-active");
      btn_2.classList.remove("btn-active");
    } else if (!parking && btn_1 && btn_2) {
      btn_2.classList.add("btn-active");
      btn_1.classList.remove("btn-active");
    }
  }, [parking, btn_1, btn_2]);

  const elements = Array.from({ length: 90 }, (_, index) => (
    <div key={index} className="item">
      {renderPlace1(index)} <div className="circle-down"></div>
    </div>
  ));

  // Sekcje podzielone na 74, 73, i 73 elementy
  const section1 = elements;

  return (
    <>
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"
        rel="stylesheet"
        integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN"
        crossorigin="anonymous"
      ></link>
      <ReservationModal
        setChange={setChange}
        change={change}
        parking={parking}
        open={open}
        setOpen={setOpen}
        changeType={changeType}
        place={place}
        collection={'parking2'}
        documentId={'mQ3zxWVUE914aWxKcXVA'}
      />

      <EditModal
        setChange={setChange}
        change={change}
        open={open2}
        setChangeType={setChangeType}
        changeType={changeType}
        setOpen={setOpen2}
        placeData={placeData}
        collection={'parking2'}
        documentId={'mQ3zxWVUE914aWxKcXVA'}
      />
      <div
        className="content"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="container">
        <div className="fence">
          <h3 style={{ textAlign: "center", marginBottom: '1rem' }}>PARKING 2</h3>
          <div className="section-2">{section1}</div>
          <div className="access-4"><p>ACCESS</p></div>
          <div className="wall-2"><p></p></div>
          <div className="road-2"><p>ROAD</p></div>
        </div>
        </div>
      </div>
    </>
  );
}
